import React from 'react';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import store from './store';
import Routes from './routes';
import { GlobalStyle } from './styles/global';
import 'react-toastify/dist/ReactToastify.css';
import 'antd/dist/antd.css';

function App() {
  return (
    <Provider store={store}>
      <GlobalStyle />
      <Routes />
      <ToastContainer />
    </Provider>
  );
}

export default App;
